import PropTypes from 'prop-types';
import React from 'react';

export default class DateTimeToolTip extends React.Component {
    getDateFormat(format) {
        var formats = {
            long: {
                weekday: 'short',
                day: 'numeric',
                month: 'short',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                hour12: false,
                timeZoneName: 'short'
            },
            short: {
                weekday: 'numeric',
                day: 'numeric',
                month: 'numeric'
            }
        };

        return formats.hasOwnProperty(format)
            ? formats[format]
            : formats.long;
    }

    getDateString() {
        const date = new Date(this.props.date);

        if (window.Intl) {
            // Temporary try catch to help debug: https://app.bugsnag.com/99designs/contests-js/errors/57bbef5550ddfc58161c042a
            // FIXME: Daniel Williams - remove bugsnag logging and try..catch
            // when bug resolved
            try {
                return Intl.DateTimeFormat(
                    this.context.locales,
                    this.getDateFormat(this.props.format)
                ).format(date);
            } catch(e) {
                if (window.Bugsnag) {
                    const errorMetaData = {
                        special_info: {
                            locales: this.context.locales,
                            date: date,
                            dateProp: this.props.date,
                            format: this.props.format
                        }
                    };

                    window.Bugsnag.notifyException(
                        e,
                        "DateTimeToolTip error",
                        errorMetaData,
                        "error"
                    );
                }

                return "";
            }
        } else {
            return '';
        }
    }

    render() {
        return (
            <span title={this.getDateString()}>
                {this.props.children}
            </span>
        );
    }
}

DateTimeToolTip.propTypes = {
    date: PropTypes.any.isRequired,
    format: PropTypes.oneOf(['long', 'short'])
};

DateTimeToolTip.defaultProps = {
    format: 'long'
};



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/DateTimeToolTip.jsx